import {
  axis,
  text,
  view,
  fontDark,
  font,
  fontSizeBig,
  fontColor,
  fontBlack,
  strokeDash,
} from '@/config/charts';
import getPercentBetween from '@/utils/getPercentBetween';

const minSize = 550;
const maxSize = 3200;

const getSizeIndicatorChartSpec = ({
  data,
  min,
  max,
  dataFormat,
}) => {
  const currentPct = getPercentBetween({ min, max, current: data.values[0].value });
  const currentCircleTextPos = (currentPct / -5) - 5;
  const currentCircleSize = minSize + ((maxSize - minSize) / 100) * currentPct;

  const labelTextCfg = {
    type: 'text',
    fontWeight: axis.labelFontWeight,
    font: axis.labelFont,
    fontSize: axis.labelFontSize,
    color: axis.labelColor,
  };

  return {
    data,
    config: {
      view,
      axis: {
        ...axis,
        tickCount: 2,
        format: dataFormat,
        domainDash: strokeDash,
        domainWidth: 2,
        labels: false,
      },
      text,
    },
    width: 'container',
    encoding: {
      x: {
        field: 'value',
        type: 'quantitative',
        scale: {
          domain: [min, max],
        },
        axis: {
          values: [
            min,
            Math.round((min + max) / 2) || null, // middle value, fallback to null to hide it
            max,
          ],
        },
      },
    },

    transform: [
      { calculate: `${min}`, as: 'min' },
      { calculate: `${max}`, as: 'max' },
    ],

    layer: [
      {
        mark: {
          type: 'text',
          fontWeight: 800,
          font,
          fontSize: fontSizeBig,
          color: fontDark,
        },
        encoding: {
          // calc text position relative to the size indicator marks percentage
          y: { value: currentCircleTextPos },
          text: { field: 'value', format: dataFormat },
        },
      },

      {
        mark: labelTextCfg,
        encoding: {
          x: { field: 'min' },
          y: { value: 50 },
          text: { field: 'min', format: dataFormat },
        },
      },

      {
        mark: labelTextCfg,
        encoding: {
          x: { field: 'max' },
          y: { value: 70 },
          text: { field: 'max', format: dataFormat },
        },
      },

      {
        mark: {
          type: 'circle',
          size: minSize,
          opacity: 1,
          color: fontColor,
        },
        encoding: {
          y: { value: 20 },
          x: { field: 'min' },
        },
      },
      {
        mark: {
          type: 'circle',
          size: maxSize,
          opacity: 1,
          color: fontColor,
        },
        encoding: {
          y: { value: 20 },
          x: { field: 'max' },
        },
      },

      {
        mark: {
          type: 'circle',
          size: currentCircleSize,
          opacity: 1,
          color: fontBlack,
        },
        encoding: {
          y: { value: 20 },
        },
      },
    ],
  };
};

export default getSizeIndicatorChartSpec;
